// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"6":"3ae924cf","77":"1a25164c","247":"407b09b8","340":"aab4ee78","399":"2bf42719","669":"d50d18d1"}[chunkId] + ".js";
};